let pendingSection: string | null = null;

export function sectionId(href: string): string | null {
  const id = href.split("#")[1];
  return id ? id : null;
}

export function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  window.history.replaceState(null, "", `/#${id}`);
  if (id === "check") {
    window.dispatchEvent(new Event("powlo-focus-postcode"));
  }
}

export function queueSection(id: string) {
  pendingSection = id;
}

export function consumeQueuedSection() {
  const id = pendingSection || window.location.hash.replace(/^#/, "");
  pendingSection = null;
  if (!id) return;
  window.requestAnimationFrame(() => scrollToSection(id));
}
